import React from 'react'
import { Card, Input, Space, Button, Spin } from 'antd'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'
import { useRoles } from '../hooks/useRoles'
import { useRoleActions } from '../hooks/useRoleActions'
import { RolesTable } from '../components/RolesTable'
import { RoleFormModal } from '../components/RoleFormModal'
import { usePermission } from '../../../auth/hooks/usePermission'

export const RolesScreen: React.FC = () => {
    const { hasPermission } = usePermission()
    const {
        roles,
        searchText, setSearchText,
        isLoading
    } = useRoles()

    const {
        isFormModalOpen,
        editingRole,
        handleCreateRole,
        handleEditRole,
        handleDeleteRole,
        handleFormSubmit,
        closeFormModal,
        isSubmitting
    } = useRoleActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search roles..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    {hasPermission('roles.create') && (
                        <Button type="primary" icon={<PlusOutlined />} onClick={handleCreateRole}>
                            Create Role
                        </Button>
                    )}
                </Space>

                <Spin spinning={isLoading}>
                    <RolesTable
                        roles={roles}
                        onEdit={handleEditRole}
                        onDelete={handleDeleteRole}
                    />
                </Spin>
            </Card>

            <RoleFormModal
                open={isFormModalOpen}
                onCancel={closeFormModal}
                onSubmit={handleFormSubmit}
                initialValues={editingRole}
                loading={isSubmitting}
            />
        </Space>
    )
}
